
define('text!common/views/commercial/creatives/manual-multiple-button.html',[],function () { return '<p class="lineitem__cta button button--primary button--small">\n    <%=offerlinktext%><%=arrowRight%>\n</p>\n';});

